import { gql } from '@apollo/client';
import { ApprovalStatus, TestResult } from '../../../../types/backflowTest';

export const GET_TEST_REPORT_IDS = gql`
  query GetTestReportIds(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    backflowTests(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
      groupBy: ["jobId"]
    ) {
      jobId
    }
  }
`;

export const GET_TEST_REPORTS = gql`
  query GetTestReports(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    backflowTests(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
    ) {
      jobId
      waterSupplierStatus
      dateTested
      initialResult
      finalResult
      testingCompanyName
      testingCompanySubmitted
      testerName
      backflowAssemblyEdited
      properlyInstalled
      testable
      job(required: true) {
        address(required: true) {
          id
          street1
          street2
          city
          state
          zip
          zipExt
        }
        attachments {
          id
        }
      }
      backflowAssembly {
        model {
          name
          backflowAssemblyMake {
            name
          }
        }
        serialNumber
        size
        type
        location
        waterService {
          siteNumber
          pin
          serviceAddresses(where: { active: true }, required: true) {
            customer(where: { status: 1 }, required: true) {
              profile {
                name
              }
            }
          }
        }
      }
    }
  }
`;

export type TestReportItem = {
  jobId: string;
  waterSupplierStatus?: ApprovalStatus;
  dateTested: string;
  initialResult?: TestResult;
  finalResult?: TestResult;
  testingCompanyName: string;
  testingCompanySubmitted: number;
  testerName: string;
  backflowAssemblyEdited: boolean;
  properlyInstalled: boolean;
  testable: boolean;

  job: {
    address: {
      street1: string;
      street2?: string;
      city: string;
      state: string;
      zip: string;
      zipExt?: string;
    };
    attachments?: {
      id: string;
      type?: string;
      contentType?: string;
      url?: string;
      thumb?: string;
      profile?: {
        id: string;
        name: string;
      };
      created?: number;
    }[];
    // submitted
    // customer
    // testing company
    // tester
  };
  backflowAssembly?: {
    model: {
      name: string;
      backflowAssemblyMake: {
        name: string;
      };
    };
    serialNumber: string;
    size: string | number;
    type: string;
    location: string;
    waterService: {
      siteNumber: string;
      serviceAddresses: {
        customer: {
          profile: {
            name: string;
          };
        };
      }[];
    };
  };
};
